import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { UserCreate } from '../../services';

export const fetchUserCreate = createAsyncThunk(
    'userCreate/fetchUserCreate',
    async ({ firstName, lastName, userName, email, phoneNumber, password }) => {
        const response = await UserCreate(firstName, lastName, userName, email, phoneNumber, password)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const userCreateSlice = createSlice({
    name: 'userCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUserCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchUserCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default userCreateSlice.reducer;
